import React from 'react';
import { Link } from "react-router-dom";

export default function CreateButton({ createButtonTitle, to, id, dataToggle, dataTarget, variant }) {
    // support multiple named variants
    const variantClass =
        variant === 'big-action'
            ? 'big-action-btn'
            : variant === 'nav-active'
            ? 'nav-active-btn'
            : variant === 'small-filled'
            ? 'small-filled-btn'
            : '';

    return (
        <Link to={to || '#'} className={`action-btn ${variantClass}`} id={id} data-toggle={dataToggle} data-target={dataTarget}>
            <span className="action-btn-label">{createButtonTitle}</span>
        </Link>
    )
} 